$(function () {
  initFilterEvents();
  initPriceSliderFromUrl();
  showSelectedFiltersFromCheckedInputs();

  // Load default products only if product grid is empty
  if ($("#collection-product").children().length === 0) {
    loadDefaultProducts();
  }
});

function initFilterEvents() {
  $(document).on("click", ".u_accordian_filter_head", function () {
    const body = $(this).next(".u_accordian_filter_body");

    if (body.hasClass("active")) {
      body.removeClass("active").slideUp();
      $(this).find(".u_filter_icon i").addClass("fa-angle-down").removeClass("fa-angle-up");
    } else {
      body.addClass("active").slideDown();
      $(this).find(".u_filter_icon i").addClass("fa-angle-up").removeClass("fa-angle-down");
    }
  });

  $(document).on("click", ".u_see_more_val", function () {
    $(this).closest(".u_accordian_filter_body").find(".u_more_value_block").show();
    $(this).closest(".u_accordian_filter_body").find(".u_see_less_val").show();
    $(this).hide();
  });

  $(document).on("click", ".u_see_less_val", function () {
    $(this).closest(".u_accordian_filter_body").find(".u_more_value_block").hide();
    $(this).closest(".u_accordian_filter_body").find(".u_see_more_val").show();
    $(this).hide();
  });

  $(document).on("click", ".js-mobile-sidebar", function () {
    $(".u_mb_cross_filter").show();
  });

  $(document).on("click", ".u_mb_cross_filter,.u_mb_filter_btn_wrapper,.u_filter_overlay", function () {
    $("html").removeClass("open_sidebar");
    $(".mask-overlay").removeClass("mask_opened");
    $(".u_mb_cross_filter").hide();
  });

  $(document).on("change", ".u_check_input", function () {
    ajaxFilterRequest(true);
  });

  $(document).on("click", ".custom-selected-filter-span", function () {
    const title = $(this).find("em").text().toLowerCase().trim();

    $(".u_filter_span").each(function () {
      const filterVal = ($(this).attr("filter_val") || "").toLowerCase().trim();

      if (filterVal === title) {
        $(this).closest("label, li, div").find(".u_check_input").prop("checked", false);
      }
    });

    ajaxFilterRequest(true);
  });

  $(document).on("click", ".u_clear_filters,.custom-clear-filters,.u-custom-clear-filters", function () {
    clearAllFilters();
  });

  $(document).on("click", ".custom_selected_filter_span_price", function () {
    removePriceFilter();
  });
}

function getBaseUrl() {
  return $(".u_filter_labels").attr("data-url") || window.location.pathname;
}

function loadDefaultProducts() {
  const baseUrl = getBaseUrl();

  $.ajax({
    type: "GET",
    url: baseUrl,
    dataType: "html",
    beforeSend: function () {
      $(".custom-filter-loader").show();
    },
    success: function (result) {
      updateProductsFromResult(result);
      updateFilterHtmlFromResult(result);
    },
    complete: function () {
      $(".custom-filter-loader").hide();
      window.dispatchEvent(new Event("resize"));
    },
    error: function () {
      $(".custom-filter-loader").hide();
      console.error("Default collection product load failed.");
    }
  });
}

function ajaxFilterRequest(pushUrl) {
  const finalUrl = buildFilterUrl();

  $.ajax({
    type: "GET",
    url: finalUrl,
    dataType: "html",
    beforeSend: function () {
      $(".custom-filter-loader").show();
    },
    success: function (result) {
      updateProductsFromResult(result);
      updateFilterHtmlFromResult(result);
      showSelectedFiltersFromCheckedInputs();

      if (pushUrl) {
        history.pushState({}, "", finalUrl);
      }
    },
    complete: function () {
      $(".custom-filter-loader").hide();
      window.dispatchEvent(new Event("resize"));
      initPriceSliderFromUrl();
    },
    error: function () {
      $(".custom-filter-loader").hide();
      console.error("Filter request failed.");
    }
  });
}

function buildFilterUrl() {
  const baseUrl = getBaseUrl();
  const params = [];

  $(".u_check_input:checked").each(function () {
    const name = $(this).attr("name");
    const value = $(this).val();

    if (name && value !== undefined) {
      params.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
  });

  const currentUrl = new URL(window.location.href);

  const priceGte = currentUrl.searchParams.get("filter.v.price.gte");
  const priceLte = currentUrl.searchParams.get("filter.v.price.lte");

  // Do NOT add price filter by default.
  // Add price only when URL already has price filter.
  if (priceGte !== null && priceLte !== null) {
    params.push("filter.v.price.gte=" + encodeURIComponent(priceGte));
    params.push("filter.v.price.lte=" + encodeURIComponent(priceLte));
  }

  if (params.length === 0) {
    return baseUrl;
  }

  return baseUrl + (baseUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
}

function updateProductsFromResult(result, originalUrl) {

  const $result = $(result);
  const productContainer = $result.find("#collection-product");

  console.log(productContainer.html());
console.log(productContainer.children().length);
  // Check actual rendered product HTML
  const hasProducts =
    productContainer.find("[data-product-id]").length > 0 ||
    productContainer.find(".product-item").length > 0 ||
    productContainer.find(".product--root").length > 0 ||
    productContainer.find(".grid__item").length > 0 ||
    productContainer.find(".card-wrapper").length > 0 ||
    productContainer.children().length > 0;

  if (hasProducts) {
    $("#collection-product").html(productContainer.html());
    return;
  }

  const nextPageUrl = $result.find(".custom-next-page-url").attr("href");

  if (nextPageUrl) {

    $.ajax({
      type: "GET",
      url: nextPageUrl,
      dataType: "html",
      success: function(nextResult){
        updateProductsFromResult(nextResult, nextPageUrl);
      },
      error: function(){
        $("#collection-product").html(
          '<p class="custom-filter-loader-text">No Product Found!</p>'
        );
      }
    });

    return;
  }

  $("#collection-product").html(
    '<p class="custom-filter-loader-text">No Product Found!</p>'
  );
}

function updateFilterHtmlFromResult(result) {
  const $result = $(result);

  const filterLabelsHtml = $result.find(".u_filter_labels").html();
  const filterContentHtml = $result.find(".u_filter_content").html();
  const mobileFilterHtml = $result.find(".u_mb_filter_parent").html();

  if (filterLabelsHtml !== undefined) {
    $(".u_filter_labels").html(filterLabelsHtml);
  }

  if (filterContentHtml !== undefined) {
    $(".u_filter_content").html(filterContentHtml);
  }

  if (mobileFilterHtml !== undefined) {
    $(".u_mb_filter_parent").html(mobileFilterHtml);
  }
}

function showSelectedFiltersFromCheckedInputs() {
  $(".u_selected_filter_labels").empty();
  $(".u_mb_custom_selected_filters_ul").empty();

  $(".u_check_input:checked").each(function () {
    let title = $(this).attr("data_text") || "";

    if (title.toLowerCase().trim() === "1") {
      title = "In Stock";
    } else if (title.toLowerCase().trim() === "0") {
      title = "Out of Stock";
    }

    const html =
      '<li class="custom-selected-filter-span-li">' +
      '<span class="custom-selected-filter-span">' +
      "<i>&#10005;</i><em>" + title + "</em>" +
      "</span>" +
      "</li>";

    $(".u_selected_filter_labels").append(html);
    $(".u_mb_custom_selected_filters_ul").append(html);
  });

  toggleSelectedFilterBox();
}

function toggleSelectedFilterBox() {
  const hasSelectedFilters =
    $(".u_check_input:checked").length > 0 ||
    $(".u_selected_filter_price_labels .custom-selected-filter-span-li-price").length > 0 ||
    $(".u_mb_selected_filter_price_labels .custom-selected-filter-span-li-price").length > 0 ||
    $(".u_mb_custom_selected_filters_ul .custom-selected-filter-span-li").length > 0;

  if (hasSelectedFilters) {
    $(".u_selected_filter_labels").css("display", "flex");
    $(".u_mb_custom_selected_filters").css("display", "flex");
  } else {
    $(".u_selected_filter_labels").hide();
    $(".u_mb_custom_selected_filters").hide();
  }
}

function initPriceSliderFromUrl() {
  if (!$("#slider").length || !$(".u_custom_filter_price").length) return;

  const maxPrice = parseInt($(".u_custom_filter_price").attr("max-price")) || 0;
  const symbol = $(".u_custom_filter_price").attr("symbol") || "";

  const currentUrl = new URL(window.location.href);

  let min = parseInt(currentUrl.searchParams.get("filter.v.price.gte"));
  let max = parseInt(currentUrl.searchParams.get("filter.v.price.lte"));

  if (isNaN(min)) min = 0;
  if (isNaN(max)) max = maxPrice;

  if ($("#slider").hasClass("ui-slider")) {
    $("#slider").slider("destroy");
  }

  $("#slider").slider({
    range: true,
    min: 0,
    max: maxPrice,
    values: [min, max],
    slide: function (event, ui) {
      $("#slider .u_left_ui_price").text(symbol + ui.values[0]);
      $("#slider .u_right_ui_price").text(symbol + ui.values[1]);
    },
    stop: function (event, ui) {
      applyPriceFilter(ui.values[0], ui.values[1]);
    }
  });

  $("#slider span:nth-child(2)").html('<p class="u_left_ui_price">' + symbol + $("#slider").slider("values", 0) + "</p>");
  $("#slider span:last-child").html('<p class="u_right_ui_price">' + symbol + $("#slider").slider("values", 1) + "</p>");

  renderPriceLabelFromUrl();
}

function applyPriceFilter(minPrice, maxPrice) {
  const baseUrl = getBaseUrl();
  const params = [];

  $(".u_check_input:checked").each(function () {
    const name = $(this).attr("name");
    const value = $(this).val();

    if (name && value !== undefined) {
      params.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
  });

  params.push("filter.v.price.gte=" + encodeURIComponent(minPrice));
  params.push("filter.v.price.lte=" + encodeURIComponent(maxPrice));

  const finalUrl = baseUrl + "?" + params.join("&");

  $.ajax({
    type: "GET",
    url: finalUrl,
    dataType: "html",
    beforeSend: function () {
      $(".custom-filter-loader").show();
    },
    success: function (result) {
      updateProductsFromResult(result);
      updateFilterHtmlFromResult(result);

      history.pushState({}, "", finalUrl);

      renderPriceLabel(minPrice, maxPrice);
      showSelectedFiltersFromCheckedInputs();
      toggleSelectedFilterBox();
    },
    complete: function () {
      $(".custom-filter-loader").hide();
      window.dispatchEvent(new Event("resize"));
      initPriceSliderFromUrl();
    },
    error: function () {
      $(".custom-filter-loader").hide();
      console.error("Price filter request failed.");
    }
  });
}

function renderPriceLabelFromUrl() {
  const currentUrl = new URL(window.location.href);

  const min = currentUrl.searchParams.get("filter.v.price.gte");
  const max = currentUrl.searchParams.get("filter.v.price.lte");

  if (min !== null && max !== null && parseInt(min) > 0) {
    renderPriceLabel(min, max);
  }
}

function renderPriceLabel(min, max) {
  const symbol = $(".u_custom_filter_price").attr("symbol") || "";

  const html =
    '<li class="custom-selected-filter-span-li-price">' +
    '<span class="custom_selected_filter_span_price">' +
    "<i>&#10005;</i><em>" + symbol + " " + min + " - " + symbol + " " + max + "</em>" +
    "</span>" +
    "</li>";

  $(".u_selected_filter_price_labels").html(html);
  $(".u_mb_selected_filter_price_labels").html(html);
}

function removePriceFilter() {
  const baseUrl = getBaseUrl();
  const params = [];

  $(".u_check_input:checked").each(function () {
    const name = $(this).attr("name");
    const value = $(this).val();

    if (name && value !== undefined) {
      params.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
  });

  const finalUrl = params.length ? baseUrl + "?" + params.join("&") : baseUrl;

  $(".u_selected_filter_price_labels").empty();
  $(".u_mb_selected_filter_price_labels").empty();

  $.ajax({
    type: "GET",
    url: finalUrl,
    dataType: "html",
    beforeSend: function () {
      $(".custom-filter-loader").show();
    },
    success: function (result) {
      updateProductsFromResult(result);
      updateFilterHtmlFromResult(result);

      history.pushState({}, "", finalUrl);

      showSelectedFiltersFromCheckedInputs();
      toggleSelectedFilterBox();
    },
    complete: function () {
      $(".custom-filter-loader").hide();
      window.dispatchEvent(new Event("resize"));
      initPriceSliderFromUrl();
    }
  });
}

function clearAllFilters() {
  const baseUrl = getBaseUrl();

  $(".u_check_input").prop("checked", false);
  $(".u_selected_filter_labels").empty();
  $(".u_mb_custom_selected_filters_ul").empty();
  $(".u_selected_filter_price_labels").empty();
  $(".u_mb_selected_filter_price_labels").empty();

  $.ajax({
    type: "GET",
    url: baseUrl,
    dataType: "html",
    beforeSend: function () {
      $(".custom-filter-loader").show();
    },
    success: function (result) {
      updateProductsFromResult(result);
      updateFilterHtmlFromResult(result);

      history.pushState({}, "", baseUrl);
      toggleSelectedFilterBox();
    },
    complete: function () {
      $(".custom-filter-loader").hide();
      window.dispatchEvent(new Event("resize"));
      initPriceSliderFromUrl();
    },
    error: function () {
      $(".custom-filter-loader").hide();
      console.error("Clear filter request failed.");
    }
  });
}